export default "__VITE_ASSET__81c04e5b__"